

export const cashback = (profits) => ({
	type: 'cashBack',
	payload: {
		profits: profits
	},
})

// export const productCount = (productCount) =>({
// 	type: 'productCount',
// 	payload: {
// 		productCount: productCount
// 	},
// })

